import React from 'react';

import clsx from 'classnames';

export function Title({
  children,
  className,
  color,
  italic,
  secondary,
  variant = 'display',
  ...props
}) {
  const titleClass = clsx(
    {
      'cdl-title': true,
      'cdl-title--italic': italic,
      'cdl-title--secondary': secondary,

      'cdl-title--display': variant === 'display',
      'cdl-title--title-1': variant === 'title-1',
      'cdl-title--title-2': variant === 'title-2',
      'cdl-title--title-3': variant === 'title-3',
      'cdl-title--title-4': variant === 'title-4',
      'cdl-title--title-5': variant === 'title-5',
      'cdl-title--overline': variant === 'overline',

      'cdl-title--foreground-primary': color === 'foreground-primary',
      'cdl-title--foreground-secondary': color === 'foreground-secondary',
      'cdl-title--foreground-tertiary': color === 'foreground-tertiary',
      'cdl-title--brand-primary-base': color === 'brand-primary-base',
      'cdl-title--brand-secondary-base': color === 'brand-secondary-base',
      'cdl-title--brand-tertiary-base': color === 'brand-tertiary-base',
      'cdl-title--brand-accent-base': color === 'brand-accent-base',
    },
    className
  );

  return (
    <h1 className={titleClass} {...props}>
      {children}
    </h1>
  );
}
